import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { Controparte } from '../../../models/controparte';
import { SezioneControparti } from '../../../models/sezioni/sezione-controparti';
import { ContropartiAssociativaUpdateComponent } from './controparti-associativa-update.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [controparti-mod-associativa-update]',
  templateUrl: 'controparti-mod-associativa-update.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ContropartiModAssociativaUpdate {
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  @Output() onReturn: EventEmitter<SezioneControparti> = new EventEmitter<SezioneControparti>();
  @ViewChild('formAssociativa') formAssociativa: ContropartiAssociativaUpdateComponent;

  inizializza(urlUpdateAssociativa: string, controparte: Controparte, idSezione: string) {
    this.formAssociativa.inizializza(urlUpdateAssociativa, controparte, idSezione);
    openModal('modalmodassociativa');
  }

  createForm() {
    this.formAssociativa.createForm();
  }

  manageModal(sezioneControparti: SezioneControparti) {
      closeModal('modalmodassociativa');
      this.onReturn.emit(sezioneControparti);
  }
}
